import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { FileText, BarChart2, Home, User, LayoutDashboard, PackageSearch } from 'lucide-react';
import './NavigationBar.css';

function NavigationBar() {
  const location = useLocation();

  return (
    <Navbar bg="white" expand="lg" className="navbar-custom shadow-sm">
      <Container>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <BarChart2 className="me-2" size={24} />
          <span className="font-weight-bold">MonDashboard</span>
        </Navbar.Brand>
        
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link 
              as={Link} 
              to="/" 
              active={location.pathname === '/'}
              className="d-flex align-items-center"
            >
              <Home size={18} className="me-2" />
              Accueil
            </Nav.Link>
            
            <Nav.Link 
              as={Link} 
              to="/invoices" 
              active={location.pathname === '/invoices'}
              className="d-flex align-items-center"
            >
              <FileText size={18} className="me-2" />
              Factures
            </Nav.Link>
            
            <Nav.Link 
              as={Link} 
              to="/dashboard" 
              active={location.pathname === '/dashboard'}
              className="d-flex align-items-center"
            >
              <LayoutDashboard size={18} className="me-2" />
              Dashboard
            </Nav.Link>

            <Nav.Link 
              as={Link} 
              to="/products" 
              active={location.pathname === '/products'}
              className="d-flex align-items-center"
            >
              <PackageSearch size={18} className="me-2" />
              Products
            </Nav.Link>
          </Nav>

          <Nav>
            <Nav.Link as={Link} to="/profile" className="d-flex align-items-center">
              <User size={18} className="me-2" />
              John Doe
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavigationBar;